import { include } from 'underscore.string';
import Promise from 'bluebird';
import { locationRecommendationConverter } from './util/locationRecommendationConverter';

export const getOdataPath = (originalHost) => {
  if (include(window.location.host, 'ads')) {
    return '/ODataApi/';
  } else if (originalHost && include(originalHost, '823')) {
    // add this condition to not change any logic for old ui
    // since this package is shared both in old ui and new ui.
    return originalHost;
  }
  const hostReg = /(.*:)(\d+)(\/.*)/g;
  return originalHost ? originalHost.replace(hostReg, '$1823$3') : originalHost;
};

export function getRecommendations({
  deps,
  scope,
  oppType,
  channel,
  top,
  skip,
}) {
  if (oppType === 'NewLocationTargetOpportunity') return new Promise(resolve => resolve({ value: [] }));
  const baseUrl = `/AdInsight/V2/Customers(${scope.customerId})/Accounts(${scope.accountId})`;
  const actionUrl = `Opportunity.GetDetails(oppTypes=['${oppType}'],channel='${channel}')?$top=${top}&$skip=${skip}`;
  const url = scope.campaignId ? `${baseUrl}/Campaigns(${scope.campaignId})/${actionUrl}` : `${baseUrl}/${actionUrl}`;
  return deps.httpUtils.odata.get({
    url,
    ...deps.odataOptions,
    host: getOdataPath(deps.odataOptions && deps.odataOptions.host),
  }).then(data => locationRecommendationConverter({ data }));
}
